interface AppEnv {
  appEnvironment: 'staging' | 'production';
  apiBaseUrl: string;
  devApiBaseUrl: string;
  appSalt: string;
  encryptionKey: string;
  sentryDsn?: string;
  release: string;
  encryptionKeyOld?: string;
}

const appEnvironment =
  import.meta.env.VITE_APP_ENV === 'production' || import.meta.env.MODE === 'production'
    ? 'production'
    : 'staging';

export const env: AppEnv = {
  appEnvironment,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://internal.ctech.works',
  devApiBaseUrl: import.meta.env.VITE_DEV_API_BASE_URL ?? 'https://dev.internal.ctech.works',
  appSalt: import.meta.env.VITE_APP_SALT,
  encryptionKey: import.meta.env.VITE_ENCRYPTION_KEY,
  encryptionKeyOld: import.meta.env.VITE_ENCRYPTION_KEY_OLD,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_RELEASE ?? 'local'
};
